/**
 * File Name          : app-response-packet.model.ts
 * Author             : Jared Laine Dyreson
 * Version            : 0.0.0
 * Date               : 2026-03-18
 * Description        : Short Description (manual edit required)
 * 
 * Copyright (C) Innovative Design Labs, Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * This file is subject to the terms and conditions defined in
 * file 'IDL_BACKGROUNDTECH_LICENSE.txt', which is part of this source code package.
 */

import { Packet } from "./packet.model";

export class AppResponsePacket extends Packet {
    mPktSubType: number | null = null;

    static fromPacket(pkt: Packet): [boolean, AppResponsePacket] {
        var thisPkt = new AppResponsePacket()

        thisPkt.mBytes = pkt.mBytes
        thisPkt.mPayloadLength = pkt.mPayloadLength
        thisPkt.mPacketNumber = pkt.mPacketNumber
        thisPkt.mPacketType = pkt.mPacketType

        thisPkt.rxCRC = pkt.rxCRC
        thisPkt.calcCRC = pkt.calcCRC
        thisPkt.validCRC = pkt.validCRC

        thisPkt.parseTypeHeader()

        var success = true

        return [success, thisPkt]
    }

    parseTypeHeader() {
        this.mPktSubType = this.mBytes![5]
    }
}